function ApiException(message, cause) {
    this.message = message;
    this.cause = cause;
    this.name = 'ApiException';
}

export default {
    ApiException
};
